export default function useAdmin() {
  const isAdmin = localStorage.getItem("a");
  return isAdmin && isAdmin === "1";
}
